/* eslint-disable no-console */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { ApplicationState } from 'store';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import { QUOTE_INTRO_PATH } from 'services/conlicitaseg';
import {
  QuoteStep,
  getDefaultQuoteFlow,
  getQuoteFlowConfig,
  getQuoteStepPath,
  getQuoteSteps,
  getStepIndicatorProps,
  isExecucao,
} from 'services/conlicitaseg_flow';
import useCanUploadContract from 'hooks/useCanUploadContract';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';

function useQuoteFlow() {
  const { quote_flow, guarantee_type, formProcess, current_process_id } = useSelector<
    ApplicationState,
    ConlicitasegState
  >((state) => state.session.conlicitaseg);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const canUploadContract = useCanUploadContract();
  const { pathname } = useLocation();
  const history = useHistory();

  const flow = quote_flow || getDefaultQuoteFlow(isOnlyConlicitaseg);

  useEffect(() => {
    if (!quote_flow && pathname !== QUOTE_INTRO_PATH) {
      console.warn(`[ConlicitaSeg] Cotação sem fluxo definido em ${pathname}; usando "${flow}".`);
    }
  }, [quote_flow, pathname]);

  useEffect(() => {
    if (current_process_id && pathname !== QUOTE_INTRO_PATH) {
      history.replace('/conlicitaseg');
    }
  }, []);

  const resolveExecucao = (typeWarrantyId: string = formProcess.type_warranty_id) =>
    isExecucao(typeWarrantyId, guarantee_type);

  const stepIndicatorProps = (step: QuoteStep, typeWarrantyId?: string) =>
    getStepIndicatorProps(flow, step, resolveExecucao(typeWarrantyId), canUploadContract);

  return {
    flow,
    config: getQuoteFlowConfig(flow, canUploadContract),
    isExecucao: resolveExecucao(),
    pathFor: (step: QuoteStep) => getQuoteStepPath(step),
    previousPathFor: (step: QuoteStep) => {
      const { links, currentStep } = stepIndicatorProps(step);
      return currentStep > 0 ? links[currentStep - 1] : null;
    },
    nextPathFor: (step: QuoteStep, typeWarrantyId?: string) => {
      const steps = getQuoteSteps(flow, resolveExecucao(typeWarrantyId), canUploadContract);
      const next = steps[steps.indexOf(step) + 1];
      return next ? getQuoteStepPath(next) : null;
    },
    stepIndicatorProps,
  };
}

export default useQuoteFlow;
